export const OCP = "ocpId";
export const PROPERTY_NAME = "propertyName";
export const REPORTER = "reporterName";
export const STATUS = "status";
export const REPORTED_ON = "receiptDate";

export const ocpStatus = {
  INTAKE: "Intake",
  FEES_CAPTURED: "Fees Captured",
  COMPLETED: "Onboarding Inprogress",
  OWNER_ONBOARDED: "Owner Onboard",
  OWNERSHIP_CHANGE_DOC: "Ownership Changed",
  CANCELLED: "Cancelled"
}
